import {
  azure,
  blue,
  gray,
  green,
  orange,
  purple,
  red,
  yellow,
} from './foundation-colors.js';

const light = {
  'cs-background': '#F1F1F1',
  'brand-background': gray[1],
  'brand-background-secondary': gray[3],
  'brand-text': gray[15],
  'brand-text-secondary': gray[13],
  'brand-link': blue[13],
  'brand-link-hover': blue[14],

  // Border
  'brand-border': gray[8],
  'brand-border-secondary': gray[7],
  'brand-border-info': azure[8],
  'brand-border-success': green[5],
  'brand-border-caution': yellow[5],
  'brand-border-warning': orange[8],
  'brand-border-critical': red[8],
  'brand-border-magic': purple[6],
  'brand-border-magic-secondary': purple[11],
  'brand-border-inverse': gray[13],

  // Surface
  'brand-surface': gray[1],
  'c-surface': gray[1],
  'c-surface-hover': gray[4],
  'c-surface-active': gray[5],
  'c-surface-selected': gray[6],
  'c-surface-secondary': gray[4],
  'c-surface-secondary-hover': gray[6],
  'c-surface-secondary-active': gray[7],
  'c-surface-secondary-selected': gray[7],
  'brand-surface-secondary': gray[4],
  'brand-surface-tertiary': gray[6],
  'brand-surface-inverse': gray[15],
  'brand-surface-info': azure[3],
  'brand-surface-info-hover': azure[4],
  'brand-surface-info-active': azure[6],
  'brand-surface-success': green[3],
  'brand-surface-success-hover': green[4],
  'brand-surface-success-active': green[5],
  'brand-surface-caution': yellow[2],
  'brand-surface-caution-hover': yellow[3],
  'brand-surface-caution-active': yellow[4],
  'brand-surface-warning': orange[3],
  'brand-surface-warning-hover': orange[4],
  'brand-surface-warning-active': orange[5],
  'brand-surface-critical': red[4],
  'brand-surface-critical-hover': red[5],
  'brand-surface-critical-active': red[6],
  'brand-surface-magic': purple[2],
  'brand-surface-magic-hover': purple[3],
  'brand-surface-magic-active': purple[5],
  'c-surface-emphasis': blue[3],
  'c-surface-emphasis-hover': blue[4],
  'c-surface-emphasis-active': blue[5],

  // Fill
  'brand-fill': gray[1],
  'brand-fill-tertiary': gray[8],
  'brand-fill-tertiary-hover': gray[9],
  'brand-fill-tertiary-active': gray[10],
  'brand-fill-brand': blue[11],
  'brand-fill-info': azure[9],
  'brand-fill-success': green[12],
  'brand-fill-caution': yellow[6],
  'brand-fill-warning': orange[9],
  'brand-fill-critical': red[12],
  'brand-fill-magic': purple[12],
  'brand-fill-inverse': gray[15],

  // Text
  'c-text-magic': purple[14],
  'c-text-magic-secondary': purple[13],
};

const dark = {
  'cs-background': 'hsl(200, 8.0%, 12%)',
  'brand-background': 'hsl(200, 8.0%, 12%)',
  'brand-background-secondary': 'hsl(200, 7.0%, 8.8%)',
  'brand-text': gray[8],
  'brand-text-secondary': gray[11],
  'brand-link': blue[13],
  'brand-link-hover': blue[14],

  // Border
  'brand-border': gray[14],
  'brand-border-secondary': gray[13],
  'brand-border-info': azure[14],
  'brand-border-success': green[5],
  'brand-border-caution': yellow[5],
  'brand-border-warning': orange[8],
  'brand-border-critical': red[8],
  'brand-border-magic': purple[6],
  'brand-border-magic-secondary': purple[11],
  'brand-border-inverse': gray[13],

  // Surface
  'brand-surface': gray[15],
  'c-surface': gray[15],
  'c-surface-hover': gray[14],
  'c-surface-active': gray[15],
  'c-surface-selected': gray[15],
  'c-surface-secondary': 'hsl(200, 7.0%, 8.8%)',
  'c-surface-secondary-hover': gray[14],
  'c-surface-secondary-active': gray[15],
  'c-surface-secondary-selected': gray[15],
  'brand-surface-secondary': 'hsl(200, 7.0%, 8.8%)',
  'brand-surface-tertiary': gray[6],
  'brand-surface-inverse': gray[15],
  'brand-surface-info': azure[15],
  'brand-surface-info-hover': azure[4],
  'brand-surface-info-active': azure[6],
  'brand-surface-success': green[3],
  'brand-surface-success-hover': green[4],
  'brand-surface-success-active': green[5],
  'brand-surface-caution': yellow[15],
  'brand-surface-caution-hover': yellow[14],
  'brand-surface-caution-active': yellow[16],
  'brand-surface-warning': orange[3],
  'brand-surface-warning-hover': orange[4],
  'brand-surface-warning-active': orange[5],
  'brand-surface-critical': red[4],
  'brand-surface-critical-hover': red[5],
  'brand-surface-critical-active': red[6],
  'brand-surface-magic': purple[16],
  'brand-surface-magic-hover': purple[15],
  'brand-surface-magic-active': purple[15],
  'c-surface-emphasis': blue[3],
  'c-surface-emphasis-hover': blue[4],
  'c-surface-emphasis-active': blue[5],

  // Fill
  'brand-fill': gray[1],
  'brand-fill-tertiary': gray[15],
  'brand-fill-tertiary-hover': gray[14],
  'brand-fill-tertiary-active': gray[13],
  'brand-fill-brand': blue[11],
  'brand-fill-info': azure[9],
  'brand-fill-success': green[12],
  'brand-fill-caution': yellow[6],
  'brand-fill-warning': orange[9],
  'brand-fill-critical': red[12],
  'brand-fill-magic': purple[12],
  'brand-fill-inverse': gray[15],

  // Text
  'c-text-magic': purple[14],
  'c-text-magic-secondary': purple[9],
};

/**
 * Exported Commslayer semantic colors.
 */
export const semanticColors = {
  light,
  dark,
};
